'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvalidContractNetworkModal = function InvalidContractNetworkModal(_ref) {
  var contractNetworkName = _ref.contractNetworkName,
      networkName = _ref.networkName,
      appName = _ref.appName;
  return _react2.default.createElement(
    'div',
    { className: 'invalid-contract-network-modal' },
    _react2.default.createElement(
      'h2',
      null,
      'Action Required'
    ),
    _react2.default.createElement(
      'p',
      null,
      'We\'ve detected that you are on the ',
      networkName,
      ' network.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'To use ',
      appName,
      ', please switch to the ',
      contractNetworkName,
      ' network.'
    )
  );
};

InvalidContractNetworkModal.defaultProps = {
  appName: 'the app'
};

InvalidContractNetworkModal.propTypes = {
  contractNetworkName: _propTypes2.default.string.isRequired,
  networkName: _propTypes2.default.string.isRequired,
  appName: _propTypes2.default.string
};

exports.default = InvalidContractNetworkModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/InvalidContractNetworkModal.js
// module id = 1198
// module chunks = 0